const resizeImage = function (file) {
  const reader = new FileReader();
  const image = new Image();
  const canvas = document.createElement("canvas");

  const resize = function () {
    // 3:4 aspect ratio. Image-migration quality jump (2026-06-18): 1200x1600 q0.88
    // matches the mobile cropAndResizeImage target + the server DOOR.orig size, so
    // web-uploaded client photos render at the same fidelity as mobile door photos.
    // Egress-safe once base64 is dropped from read payloads (Phase C, done) and from
    // the DB (Phase G). NOTE: this still STRETCHES the source into 3:4 (5-arg
    // drawImage) — non-3:4 uploads are distorted, just at higher resolution now. A
    // center-crop (like mobile's cropAndResizeImage) is the follow-up to true parity.
    const width = 1200;
    const height = 1600;

    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(image, 0, 0, width, height);
    let dataUrl = canvas.toDataURL("image/jpeg", 0.88);

    // Size logger
    const base64Length = dataUrl.length - dataUrl.indexOf(",") - 1;
    const approxKB = Math.round((base64Length * 0.75) / 1024);
    console.log(
      `[resizeImage] Output: ${width}x${height} @ q0.88 — ~${approxKB} KB`
    );

    return dataUrl;
  };

  return new Promise(function (ok, no) {
    if (!file.type.match(/image.*/)) {
      no(new Error("Not an image"));
      return;
    }
    reader.onload = function (readerEvent) {
      image.onload = function () {
        return ok(resize());
      };
      image.src = readerEvent.target.result;
    };
    reader.readAsDataURL(file);
  });
};

export default resizeImage;
